/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShieldAtIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACZElEQVR4nK1VOYgUURBtQURRUBc1UAPFQLxBM48dEFcWeur4K7+rendkEsXMSARFxMTATA1FRJBNvPAEXdloNRKMBCPxSASNVlhRwVWqp2emZ53pubbgQ/O7/nv9X72qDoIuoliMV9nq5kxnwBwXkGQSWWeTRTJpe/MBvB9JHyPr36aL9CVRDD0BA+uLlsC9Eg17vxpJn3cMzI0LWJ7l1ghJ7/UKjnWSO60JWGf+O0DyB1jHwekwoq713i9ybmw9umjMpGlCMpNHMFfbL4jRoIECawlJbiHJBJLcTDVfACQX5p7riABIfxHJ3jD064DlTbr/s1EOvWEkSPqge4LK4QBJppBlGlijQqGwMAxHVyLL+SLL4STXaWi37IgAWL/XEjEaJJID9kwUn/DeD5hLrMm890sAdGd608ve++V1ApnOI/hQTXSutAZIT1cIyiuA5Gz1XdLZqC4FvOq9X1avm7xvTUDypJpYKJcXI+tFc5FJY1+avptllk1FklMJGclRGIn2ZWz6KK8G52qJ4DeaNPbMPLqn6KLdZksDtlyi+JjZ1xyW7R9gPdOSgFm2ZIp13HwPpD+A5TWi31qxq4wAyRWrA5FsAJJrDTZFv7klQVqHV6m2b00mYC0Dye/OZpJM5YInMmF0KHPd8dQx25DlErA8BJanyHodXaRFio80WNvpwbYECUm2cUjeodOTJt/QUGlp4igjrIyK2mAElvtBp2HNlLUsth1w+rnrP13ool3I8q297vqVaHRH0Euk3fopp6gfQxdtD/oJ7/0Astxt8uW3Tcq+wLORDLTKqJ6wGTVvwP3GP9qJGTcqt5O5AAAAAElFTkSuQmCC)
 */
export const ShieldAtIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.81 13.23c-.3.4-.7.6-1.18.6-.4 0-.71-.14-.93-.42-.2-.27-.3-.67-.3-1.17 0-.63.15-1.14.46-1.53.32-.4.71-.6 1.2-.6.38 0 .68.14.9.42.21.27.32.66.32 1.17 0 .62-.15 1.14-.47 1.53Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4.56 4.22A2.83 2.83 0 0 0 3 6.75v3.03c0 5.6 3.3 10.69 8.42 12.96.37.17.79.17 1.16 0A14.18 14.18 0 0 0 21 9.78V6.75c0-1.07-.6-2.05-1.56-2.53l-6.1-3.05a3 3 0 0 0-2.68 0l-6.1 3.05Zm10.37 5.47a.5.5 0 0 0-.5-.57h-.22a.5.5 0 0 0-.47.34l-.14.4c-.14-.28-.36-.5-.64-.67a2.7 2.7 0 0 0-2.58.18c-.44.27-.79.67-1.04 1.18-.24.5-.37 1.09-.37 1.74 0 .85.2 1.52.62 2s.98.72 1.67.72c.45 0 .86-.1 1.23-.28.37-.2.65-.45.82-.76.05.3.2.55.44.75.25.19.57.29.97.29a3 3 0 0 0 1.7-.5c.5-.34.88-.81 1.16-1.42.28-.6.42-1.3.42-2.07a4.66 4.66 0 0 0-2.68-4.38 6.4 6.4 0 0 0-2.9-.64c-1.18 0-2.26.25-3.24.76a5.72 5.72 0 0 0-2.33 2.18A6.36 6.36 0 0 0 6 12.28c0 1.08.21 2.05.64 2.92a4.74 4.74 0 0 0 1.98 2.04c.9.5 2 .76 3.31.76.78 0 1.53-.08 2.28-.25a6.94 6.94 0 0 0 1.47-.5.46.46 0 0 0 .21-.61l-.1-.21c-.12-.27-.44-.37-.7-.26a7.5 7.5 0 0 1-3.04.58c-1.06 0-1.94-.2-2.64-.6a3.67 3.67 0 0 1-1.5-1.6 5.3 5.3 0 0 1-.46-2.26c0-1.01.22-1.9.66-2.66A4.5 4.5 0 0 1 9.9 7.87a5.23 5.23 0 0 1 2.55-.62c.82 0 1.55.15 2.18.47a3.5 3.5 0 0 1 1.48 1.34c.35.58.53 1.26.53 2.04 0 .52-.08.99-.24 1.41-.14.42-.35.75-.61.99s-.53.36-.82.36c-.34 0-.52-.2-.52-.61 0-.09 0-.15.02-.2l.46-3.36Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
